import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {AnalyticsShadowITState} from './analyticsShadowITSlice'
import {searchHeaderEveryone} from 'definitions/constant'

const selectAnalyticsState = (state: RootState): AnalyticsShadowITState =>
  state.analyticsShadowIT

// shadow IT selectors
export const selectShadowITState = createSelector(
  selectAnalyticsState,
  analyticsShadowIT => analyticsShadowIT.shadowIT,
)

export const selectShadowITSearchQuery = createSelector(
  selectShadowITState,
  shadowIT => ({
    searchTerm: shadowIT.searchTerm,
    searchType: shadowIT.searchType,
  }),
)

export const selectShadowITSearchHeaderText = createSelector(
  selectShadowITState,
  shadowIT => shadowIT.searchDisplayValue || searchHeaderEveryone,
)
